"use client";

import { EmailCaptureForm } from "@/components/retention/email-capture-form";

export function LandingNewsletter() {
  return (
    <section className="landing-newsletter">
      <div className="newsletter-inner">
        <h2 className="landing-section-title">Get niche ideas weekly</h2>
        <p className="newsletter-desc">
          Get a short weekly email with high-opportunity niches, standout
          startups, and product ideas surfaced from TrustMRR data.
        </p>
        <EmailCaptureForm
          endpoint="/api/newsletter/subscribe"
          payload={{}}
          buttonLabel="Get Weekly Report"
          successMessage="You are subscribed. The next niche report will land in your inbox."
        />
      </div>
    </section>
  );
}
